import axios from '../request/http';
import { toFormData } from '../common/descriptions'

const info = {
    // 乡村信息列表
    infoList(params) {
        return axios.get("/hemei-admin/villageInfo/pageList", { params });
    },
    // 新增乡村
    addVillage(data) {
        return axios.post("/hemei-admin/villageInfo/addVillage", data);
    },
    // 获取城市列表
    getCityList(params) {
        return axios.get("/service-app/village/children/areaId", { params });
    },
    // 修改乡村状态
    updStatus(data) {
        return axios.post("/hemei-admin/villageInfo/updStatus", toFormData(data));
    },
    // 乡村详情
    detail(id) {
        return axios.get("/hemei-admin/villageInfo/detail/" + id);
    },
    // 获取账号基本信息
    getInfo(params) {
        return axios.get("/hemei-admin/admin/getInfo", { params });
    },
    // 升级为电商管理员
    updManageType(data) {
        return axios.post("/hemei-admin/villageInfo/updManageType", toFormData(data));
    },
    // 重置管理员密码
    updManagePwd(data) {
        return axios.post("/hemei-admin/villageInfo/updManagePwd", toFormData(data));
    },
    // 获取乡村申请审核列表
    processList(params) {
        return axios.get("/hemei-admin/villageApplyInfo/getVillageApplyInfoPage", { params });
    },
    // 乡村申请审核
    applyProcess(data) {
        return axios.post("/hemei-admin/villageApplyInfo/updStatus", toFormData(data));
    },
    // 获取乡村服务需求广场列表
    needServiceList(params) {
        return axios.get("/hemei-admin/villageJob/getJobPage", { params });
    },
    // 更改状态
    updJobStatus(data) {
        return axios.post("/hemei-admin/villageJob/updJobStatus", toFormData(data));
    },
    // 管理员查询用户的所有文章列表 articleType文章类型 0 常规 1 党政
    getGovernmentList(params) {
        return axios.get("/service-article/article/queryAllList", { params });
    },
    // 用户删除文章
    deleteArticle(params) {
        return axios.get("/service-article/article/delete", { params });
    },
    // 新增或修改文章
    addArticle(data) {
        return axios.post("/service-article/article/create", data);
    },
    // 用户撤回文章（下架：只有绑定用户才可以下架）
    withdrawArticle(params) {
        return axios.get("/service-article/article/withdraw", { params });
    },

    // 新增修改菜单栏
    // routeList(data){
    //     return axios.post("/hemei-admin/menu/addOrUpdMenu", data );
    // },
    // 删除菜单栏
    // routeDl(params){
    //     return axios.delete("/hemei-admin/menu/delMenu", { params });
    // },

}

export default info;


// WEBPACK FOOTER //
// ./src/api/info.js